import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  gap: 0.125rem;
`
